import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroService } from '../../../shared/filtro/filtro.service';
import { FiltroDealers } from './filtro-dealer';
import { VeiculoVendidoGacFiltroService } from './veiculo-vendido-GAC-filtro.service';
import { VeiculoVendidoGacService } from './veiculo-vendido-GAC.service';

declare var $: any;

@Component({
  selector: 'app-veiculo-vendido',
  templateUrl: './veiculo-vendido-GAC.component.html',
  styleUrls: ['./veiculo-vendido-GAC.component.scss']
})
export class VeiculoVendidoGacComponent implements OnInit {
  @Input() filtros: any;
  form: FormGroup;
  subscription: any;
  data: Date;
  selecionado: object;
  selecionados = [];
  gruposEconomicos = [];
  tipo = [];
  vendaDireta = [];
  marcas = [];
  cols: any[];
  _selectedColumns: any[];
  dealersDados: any[] = [];
  numero_nfe: any;
  serie: any;
  id_dealer: any;
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  valorDataInicialRecebeParametro: any;
  valorDataFinalRecebeParametro: any;
  chassi: any;
  situacaoValue: number;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;
  validaButtonRedireciona: boolean = false;
  valorCpfRecebe: any;
  voltarTelaAnterior: any;
  valorChassiRecebe: any;
  statusNota = [
    { nome: 'NfVenda Ativa', valor: 2 },
    { nome: 'NfVenda Cancelada', valor: 1 },
    { nome: 'NfDevolução Venda', valor: 3 }
  ];

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Dealer": "relatorioVeiculos.veiculoVendido.dealer",
    "Chassi": "relatorioVeiculos.veiculoVendido.chassi",
    "Marca": "relatorioVeiculos.veiculoVendido.marca",
    "Modelo": "relatorioVeiculos.veiculoVendido.modelo",
    "Valor de Venda": "relatorioVeiculos.veiculoVendido.valorVenda",
    "Cor Externa": "relatorioVeiculos.veiculoVendido.corExterna",
    "Ano/Modelo": "relatorioVeiculos.veiculoVendido.anoModelo",
    "Tipo": "relatorioVeiculos.veiculoVendido.tipo",
    "Venda Direta": "relatorioVeiculos.veiculoVendido.vendaDireta",
    "Status": "relatorioVeiculos.veiculoVendido.status",
    "Proposta": "relatorioVeiculos.veiculoVendido.proposta",
    "Data da venda": "relatorioVeiculos.veiculoVendido.dataVenda",
    "Nota Fiscal": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.notaFiscal",
    "Nome Cliente": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.nomeCliente",
    "CPF": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cpf",
    "Chave NFe": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.chaveNfe",
    "Logradouro": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.logradouro",
    "CEP": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cep",
    "Cidade": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cidade",
    "Bairro": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.bairro",
    "Estado": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.estado",
    "Tel. Pessoal": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.pessoal",
    "Tel. Comercial": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.comercial",
    "Tel. Cobrança": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cobranca",
    "Data da Proposta": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.dataProposta",
    "Data da Compra": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.dataCompra"
  }

  constructor(private service: VeiculoVendidoGacService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: VeiculoVendidoGacFiltroService,
    private veiculoVendido: FiltroService,
    private exportExcelService: ExportExcelService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder) {
    this.filtros = {};
    this.nomeModulo = 'veiculo-vendido';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      grupo_economico: [''],
      chassi: [''],
      situacao: [''],
      marca: [''],
      placa: [''],
      vendaDireta: [''],
      status: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const temParametros = (params.chassi && params.chassi !== '') || (params.cpf && params.cpf !== '');

      if (temParametros) {
        const vdataInicial = params.dataInicial;
        const vdataFinal = params.dataFinal;
        this.valorCpfRecebe = params.cpf;
        this.chassi = params.chassi;

        if (moment(vdataInicial, 'DD/MM/YYYY', true).isValid()) {
          this.dataInicial = moment(vdataInicial, 'DD/MM/YYYY').toDate();
        } else {
          console.error('Data inicial inválida:', vdataInicial);
          this.dataInicial = new Date();
        }

        if (moment(vdataFinal, 'DD/MM/YYYY', true).isValid()) {
          this.dataFinal = moment(vdataFinal, 'DD/MM/YYYY').toDate();
        } else {
          console.error('Data final inválida:', vdataFinal);
          this.dataFinal = new Date();
        }

        this.f.data_inicial.setValue(moment(this.dataInicial).format('DD/MM/YYYY'));
        this.f.data_final.setValue(moment(this.dataFinal).format('DD/MM/YYYY'));
        this.f.chassi.setValue(this.chassi);

        console.log('Data Inicial:', this.dataInicial);
        console.log('Data Final:', this.dataFinal);

        this.getAll();
        this.validaButtonRedireciona = true;
      } else {
        this.validaButtonRedireciona = false;
      }
    });

    this.changeLanguageValue();
    this.preencherGruposEconomicos();
    this.preencherMarcas();
    this.preencherTipo();
    this.preencherVendaDireta();

    this.loading = true;

    this.cols = [
      { field: 'codDealer', header: 'relatorioVeiculos.controleProposta.gridHeader.codDealer', headerBr: 'Cód. Dealer', headerGb: 'Dealer Code', width: '120px' },
      { field: 'nome', header: 'relatorioVeiculos.veiculoVendido.dealer', headerBr: 'Dealer', headerGb: 'Dealer', width: '325px' },
      { field: 'chassi', header: 'relatorioVeiculos.veiculoVendido.chassi', headerBr: 'Chassi', headerGb: 'Chassis', width: '140px' },
      { field: 'marca', header: 'relatorioVeiculos.veiculoVendido.marca', headerBr: 'Marca', headerGb: 'Brand', width: '100px' },
      { field: 'modelo', header: 'relatorioVeiculos.veiculoVendido.modelo', headerBr: 'Modelo', headerGb: 'Model', width: '325px' },
      { field: 'valorVenda', header: 'relatorioVeiculos.veiculoVendido.valorVenda', headerBr: 'Valor de Venda', headerGb: 'Sale Value', width: '120px' },
      { field: 'corExterna', header: 'relatorioVeiculos.veiculoVendido.corExterna', headerBr: 'Cor Externa', headerGb: 'External Color', width: '100px' },
      { field: 'anoModelo', header: 'relatorioVeiculos.veiculoVendido.anoModelo', headerBr: 'Ano/Modelo', headerGb: 'Year/Model', width: '110px' },
      { field: 'situacao', header: 'relatorioVeiculos.veiculoVendido.tipo', headerBr: 'Tipo', headerGb: 'Type', width: '70px' },
      { field: 'vendaDireta', header: 'relatorioVeiculos.veiculoVendido.vendaDireta', headerBr: 'Venda Direta', headerGb: 'Direct Sale', width: '120px' },
      { field: 'data_compra', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.dataCompra', headerBr: 'Data da Compra', headerGb: 'Purchase Date', width: '190px' },
      { field: 'proposta', header: 'relatorioVeiculos.veiculoVendido.proposta', headerBr: 'Proposta', headerGb: 'Proposal', width: '100px' },
      { field: 'dataProposta', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.dataProposta', headerBr: 'Data da Proposta', headerGb: 'Proposal Date', width: '200px' },
      { field: 'nfeChave', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.chaveNfe', headerBr: 'Chave NFe', headerGb: 'NFe Key', width: '350px' },
      { field: 'status', header: 'relatorioVeiculos.veiculoVendido.status', headerBr: 'Status', headerGb: 'Status', width: '80px' },
      { field: 'numero_nfe', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.notaFiscal', headerBr: 'Nota Fiscal', headerGb: 'Invoice', width: '100px' },
      { field: 'data', header: 'relatorioVeiculos.veiculoVendido.dataVenda', headerBr: 'Data da Venda', headerGb: 'Sale Date', width: '190px', type: this.data, arg1: `dd/MM/yyyy HH:mm:ss` },
      { field: 'dtEntrega', header: 'relatorioVeiculos.veiculoVendido.dataEntrega', headerBr: 'Data de Entrega', headerGb: 'Delivery Date', width: '190px', type: this.data, arg1: `dd/MM/yyyy HH:mm:ss` },
      { field: 'email', header: 'Email', headerBr: 'Email', headerGb: 'Email', width: '300px' },
      { field: 'nomeCliente', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.nomeCliente', headerBr: 'Nome Cliente', headerGb: 'Client Name', width: '300px' },
      { field: 'cpfCliente', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cpf', headerBr: 'CPF', headerGb: 'SSN', width: '100px' },
      { field: 'logradouro', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.logradouro', headerBr: 'Logradouro', headerGb: 'Street', width: '300px' },
      { field: 'cep', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cep', headerBr: 'CEP', headerGb: 'Zip Code', width: '80px' },
      { field: 'cidade', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cidade', headerBr: 'Cidade', headerGb: 'City', width: '200px' },
      { field: 'bairro', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.bairro', headerBr: 'Bairro', headerGb: 'Neighborhood', width: '200px' },
      { field: 'estado', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.estado', headerBr: 'Estado', headerGb: 'State', width: '100px' },
      { field: 'pessoal', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.pessoal', headerBr: 'Tel. Pessoal', headerGb: 'Personal Phone', width: '110px' },
      { field: 'comercial', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.comercial', headerBr: 'Tel. Comercial', headerGb: 'Commercial Phone', width: '120px' },
      { field: 'cobranca', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cobranca', headerBr: 'Tel. Cobrança', headerGb: 'Billing Phone', width: '110px' }
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private preencherGruposEconomicos() {
    this.veiculoVendido.buscar('grupo_economico')
      .then(r => { this.gruposEconomicos = r.filtros; });
  }

  private preencherMarcas() {
    this.veiculoVendido.buscar('marca')
      .then(r => { this.marcas = r.filtros; });
  }

  private preencherTipo() {
    this.tipo = [
      { nome: 'Usado', valor: "U" },
      { nome: 'Novo', valor: "N" }
    ];
  }

  private preencherVendaDireta() {
    this.vendaDireta = [
      { nome: 'Sim', valor: "S" },
      { nome: 'Não', valor: "N" }
    ];
  }

  private getAll() {
    this.loading = true;
    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.grupo_economico.value,
      this.f.chassi.value, this.f.situacao.value, this.f.vendaDireta.value, this.f.status.value).subscribe(dados => {
        this.dealersDados = dados.dealersGac;
        this.orderByDate();

        this.dealersDados.forEach(element => {
          element.vendaDireta = element.vendaDireta || 'N';

          const atual = this.conversaoLibraConverte.conversaoLibra(element.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          element.valorVenda = valorFormatado.replace("R$", "");
          element.data = element.dataVenda;
          element.dtEntrega = element.dataEntrega;

          if (element.dataProposta != null) {
            element.dataProposta = moment(new Date(element.dataProposta)).format('DD/MM/YYYY HH:mm:ss');
          }
          if (element.data_compra != null) {
            element.data_compra = moment(element.data_compra.substring(0, 10), 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
        });

        this.loading = false;
      }, () => {
        this.loading = false;
      });
  }

  private orderByDate() {
    this.dealersDados.sort((a, b) => {
      let data_a = a.data;
      let data_b = b.data;

      if (data_a > data_b) return -1;
      if (data_a < data_b) return 1;

      return 0;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.loading = true;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();

    this.displayFiltros = false;
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.grupo_economico.value
      || this.f.chassi.value
      || this.f.situacao.value
      || this.f.marca.value
      || this.f.placa.value
      || this.f.vendaDireta.value
      || this.f.status.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.grupo_economico.setValue('');
    this.f.chassi.setValue('');
    this.f.situacao.setValue('');
    this.f.marca.setValue('');
    this.f.placa.setValue('');
    this.f.vendaDireta.setValue('');
    this.f.status.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {
    if (value.status == 'Vendido') {
      return this.translate.currentLang == "br" ? value.status = "Vendido" : value.status = "Sold";
    }

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "relatorioVeiculos.veiculoVendido.dealer") {
      return "Dealer";
    }
    if (item == "relatorioVeiculos.veiculoVendido.status") {
      return "Status";
    }
    if (item == "relatorioVeiculos.veiculoVendido.chassi") {
      return this.translate.currentLang == "br" ? "Chassi" : "Chassis";
    }
    if (item == "relatorioVeiculos.veiculoVendido.marca") {
      return this.translate.currentLang == "br" ? "Marca" : "Brand";
    }
    if (item == "relatorioVeiculos.veiculoVendido.modelo") {
      return this.translate.currentLang == "br" ? "Modelo" : "Model";
    }
    if (item == "relatorioVeiculos.veiculoVendido.valorVenda") {
      return this.translate.currentLang == "br" ? "Valor de Venda" : "Sale Value";
    }
    if (item == "relatorioVeiculos.veiculoVendido.corExterna") {
      return this.translate.currentLang == "br" ? "Cor Externa" : "External Color";
    }
    if (item == "relatorioVeiculos.veiculoVendido.anoModelo") {
      return this.translate.currentLang == "br" ? "Ano/Modelo" : "Year/Modelr";
    }
    if (item == "relatorioVeiculos.veiculoVendido.tipo") {
      return this.translate.currentLang == "br" ? "Tipo" : "Type";
    }
    if (item == "relatorioVeiculos.veiculoVendido.vendaDireta") {
      return this.translate.currentLang == "br" ? "Venda Direta" : "Direct Sale";
    }
    if (item == "relatorioVeiculos.veiculoVendido.proposta") {
      return this.translate.currentLang == "br" ? "Proposta" : "Proposal";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.dataProposta") {
      return this.translate.currentLang == "br" ? "Data da Proposta" : "Proposal Date";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.dataCompra") {
      return this.translate.currentLang == "br" ? "Data da Compra" : "Purchase Date";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.chaveNfe") {
      return this.translate.currentLang == "br" ? "Chave NFe" : "NFe Key";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.notaFiscal") {
      return this.translate.currentLang == "br" ? "Nota Fiscal" : "Invoice";
    }
    if (item == "relatorioVeiculos.veiculoVendido.dataVenda") {
      return this.translate.currentLang == "br" ? "Data de Venda" : "Sale Date";
    }
    if (item == "relatorioVeiculos.veiculoVendido.dataEntrega") {
      return this.translate.currentLang == "br" ? "Data de Entrega" : "Delivery Date";
    }
    if (item == "Email") {
      return this.translate.currentLang == "br" ? "Email" : "E-mail";
    }
    if (item == "relatorioVeiculos.controleProposta.gridHeader.codDealer") {
      return this.translate.currentLang == "br" ? "Cód. Dealer" : "Dealer Code";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.nomeCliente") {
      return this.translate.currentLang == "br" ? "Nome Cliente" : "Client Name";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cpf") {
      return this.translate.currentLang == "br" ? "CPF" : "SSN";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.logradouro") {
      return this.translate.currentLang == "br" ? "Logradouro" : "Street";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cep") {
      return this.translate.currentLang == "br" ? "CEP" : "Zip Code";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cidade") {
      return this.translate.currentLang == "br" ? "Cidade" : "City";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.bairro") {
      return this.translate.currentLang == "br" ? "Bairro" : "Neighborhood";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.estado") {
      return this.translate.currentLang == "br" ? "Estado" : "State";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.pessoal") {
      return this.translate.currentLang == "br" ? "Tel. Pessoal" : "Personal Phone";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.comercial") {
      return this.translate.currentLang == "br" ? "Tel. Comercial" : "Commercial Phone";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cobranca") {
      return this.translate.currentLang == "br" ? "Tel. Cobrança" : "Billing Phone";
    }
  }

  private translateField(item) {
    if (item == "relatorioVeiculos.veiculoVendido.statusGrid.vendido" || item == "Vendido") {
      return this.translate.currentLang == "br" ? "Vendido" : "Sold";
    }

    return item;
  }

  public detalhado(index) {
    this.numero_nfe = index.numero_nfe;
    this.serie = index.serie;
    this.id_dealer = index.id;
    this.router.navigate(['veiculo/vendido-detalhado/'], { queryParams: { numero_nfe: this.numero_nfe, serie: this.serie, dealer: this.id_dealer } });
  }

  public exportExcel() {
    let registros = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.grupo_economico.value,
      this.f.chassi.value, this.f.situacao.value, this.f.vendaDireta.value, this.f.status.value).subscribe(dados => {
        registros = dados.dealersGac;
        this.orderByDate();

        registros.forEach(dados => {
          dados.vendaDireta = dados.vendaDireta || 'N';

          const atual = this.conversaoLibraConverte.conversaoLibra(dados.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          dados.valorVenda = valorFormatado.replace("R$", "");

          const moment = require('moment');
          if (dados.dataVenda != null) {
            const dataOriginalVenda = new Date(dados.dataVenda);
            const dataFormatadaVenda = moment(dataOriginalVenda).format('DD/MM/YYYY HH:mm:ss');
            dados.data = dataFormatadaVenda;
          }
          if (dados.dataEntrega != null) {
            const dataOriginalEntrega = new Date(dados.dataEntrega);
            const dataFormatadaEntrega = moment(dataOriginalEntrega).format('DD/MM/YYYY HH:mm:ss');
            dados.dtEntrega = dataFormatadaEntrega;
          }
          if (dados.dataProposta != null) {
            dados.dataProposta = moment(new Date(dados.dataProposta)).format('DD/MM/YYYY HH:mm:ss');
          }
          if (dados.data_compra != null) {
            dados.data_compra = moment(dados.data_compra.substring(0, 10), 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
        });

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = 'Veiculo Vendido GAC';
          this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this._selectedColumns.forEach(c => {
              if (c.field != 'detalhe') {
                linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
              }
            });

            return linha;
          }));
        }
      });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.loading = true;
        this.getAll();
      });
  }

  public voltar() {
    const valorDataIncRetorna = moment(this.dataInicial).format('DD/MM/YYYY');
    const valorDataFinRetorna = moment(this.dataFinal).format('DD/MM/YYYY');
    const valorCpfRetorna = this.valorCpfRecebe;
    const valorChassiRetorna = this.chassi;

    this.router.navigate(['/bi/clv'], {
      queryParams: {
        cpf: valorCpfRetorna,
        dataInicial: valorDataIncRetorna,
        dataFinal: valorDataFinRetorna,
        chassi: valorChassiRetorna,
      }
    });
  }
}